import { Avatar, AvatarBadge, Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { HiOutlineChatAlt } from "react-icons/hi";

export const AttendeesCard = () => {
  return (
    <Flex
      width="100%"
      align={"center"}
      p="10px"
      className=" animate__animated animate__fadeInDown animate__faster"
    >
      <Flex width="90%" align={"center"}>
        <Avatar size="xs" name="John Doe">
          <AvatarBadge boxSize=".9em" bg="#38F135" />
        </Avatar>
        <Text fontSize={".7em"} color="#5C7899" ml="10px" fontWeight={"700"}>
          John Doe
        </Text>
      </Flex>
      <Box width="10%">
        <HiOutlineChatAlt size={"1.2em"} color="#38F135" />
      </Box>
    </Flex>
  );
};
